import { Injectable } from '@angular/core';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import { HttpClient } from '@angular/common/http';
import {ParentTableService} from './parent-table.service';
import {exportable$} from './decorators/exportable';
import {TestCaseResult} from '../../models/test-case';
import {HelperFunctions} from './configuration/helper-functions';
import {SQDataConfiguration} from './configuration/OData-configuration';

@Injectable({
  providedIn: 'root'
})
export class TestCaseService extends ParentTableService {
  private odata: ODataEntitySetService<TestCaseResult>;
  private readonly config: SQDataConfiguration;
  @exportable$ testcase: any;
  constructor(private odataFactory: ODataServiceFactory, private httpService: HttpClient) {
    super('TestCaseService');
    this.odata = this.odataFactory.entitySet<any>('Overview(0)/TestCase');
    this.config = new SQDataConfiguration();
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));

    let filter = '';
    let dashboard = '';
    if (filterModel.chartCode) {
      dashboard = HelperFunctions.getDashboardFiltersQuery(filterModel.chartCode);
    }
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.testcase = query;
    return this.httpService.get(this.testcase.api.serviceRootUrl + this.testcase.toString() + '&$count=true' + dashboard);
  }
}
